const initTranslations = () => {
  return fetch('/translation.json').then((res) => {
    if (res.status !== 200) {
      console.log('Looks like there was a problem. Status Code: ' + res.status);
      return;
    }
    return res.json();
  });
};

export default initTranslations;
